exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".m-tab-set{overflow:hidden;border:1px solid rgb(86.0784313725%,87.137254902%,91.4117647059%);-webkit-border-radius:4px 4px 0 0;-moz-border-radius:4px 4px 0 0;border-radius:4px 4px 0 0}", ""]);

// exports
